import { render, staticRenderFns } from "./noStock.vue?vue&type=template&id=b0044940&scoped=true&"
import script from "./noStock.vue?vue&type=script&lang=js&"
export * from "./noStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0044940",
  null
  
)

export default component.exports